import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import lodash from 'lodash';
import { parseQueryString } from '../../../utils/utils'
import useLoader from '../../../hooks/use-loader';
import apiRequest from '../../../utils/api.request';
import VaccinationDetailsContainer from "../VaccinationDetailsContainer";
import { _getErrorMessage } from '../../VaccinationDetails/VaccinationDetailsWrapper/Utils/getErrorMessage';
import {
  ess, recordEssParams
} from '../../OnBoarding/ess';
import { vaccinationApiRequestBody } from "../../VaccinationDetails/VaccinationDetailsWrapper/Utils/vaccinationApiRequestBody";
import { isJhhIdVerified } from '../../VaccinationCertificate/Utils/isJhhIdVerified';
import config from "../../../config.json";
import { useAppState } from '../../../contexts/appState'
import ErrorComponent from "../../Error-Component";
import ic_age_limit from '../../../images/ic_age_limit.png';
import ic_file_upload_success from '../../../images/ic_file_upload_success.png';
import './VaccinationInfo.css'
import useTranslation from '../../../hooks/use-translation';
import { useIsDesktop, useIsTablet } from '../../../hooks/breakpoints';
import { srGetUserVaccinationStatus, srGetVaccineOptions, srGetEoiSscParams, srUpdateVaccineInfo } from '../../../sources/my-vaccinations';
const styles = {
  headerText: {
    color: '#666666',
    fontFamily: 'JioType-Bold',
    fontSize: '20px',
    paddingTop: '1em'
  }
}

let auth_token;
let source_id;
let source_user_id;
let source_relation;
let source_user_relation_id;

const getDoseLabels = {
  'dose-1': '1',
  'dose-2': '2'
}

const VaccinationInfo = () => {
  const history = useHistory();
  const { dose = '' } = useParams()
  const { t, language } = useTranslation();
  const isDesktop = useIsDesktop();
  const isTablet = useIsTablet();
  const urlParams = new URLSearchParams(window.location.search);
  const params = parseQueryString();
  const userInfoFromParams = useRef();
  const [pageLoadError, setPageLoadError] = useState();
  const [showVaccineDetails, _setShowVaccineDetails] = useState(false);
  const [vaccineDetails, _setVaccineDetails] = useState({});
  const [fileUploaded, setFileUploaded] = useState(false)
  const [vaccinated, _setVaccinated] = useState(false);
  const [showAgeWarning, setShowAgeWarning] = useState(false)
  const [vaccineOptions, _setVaccineOptions] = useState([]);
  const { showLoading, hideLoading } = useLoader();
  const user_details = useRef();
  const eoiSscParams = useRef();
  const name = atob(lodash.get(params, 't', btoa('user')))
  const [{ user }, dispatch] = useAppState()

  const getUserVaccinationStatus = async (params) => {
    source_id = lodash.get(params, "source_id", '');
    switch (source_id) {
      case "emp_xp": {
        auth_token = lodash.get(params, "auth_token", '');
        source_user_id = lodash.get(params, "source_user_id", '');
        source_relation = lodash.get(params, "source_relation", '');
        source_user_relation_id = lodash.get(params, "source_user_relation_id", '');
        if (!auth_token || !source_user_id || !source_relation || !source_user_relation_id) {
          history.push('/');
        }
        else {
          user_details.current = {
            auth_token,
            source_id,
            source_user_id,
            source_relation,
            source_user_relation_id
          };
          //const dataObj = vaccinationApiRequestBody({}, user_details.current);
          const response = await srGetUserVaccinationStatus(source_id);
          // NOTE below data is for mocking the above api, will remove later
          // const response = {
          //   "vaccine": {
          //     "name": "Pifizer",
          //     "dose": "1",
          //     "date_of_dose": "2021-04-06",
          //     "data_source": "provider",
          //     "vaccines": [
          //       {
          //         "name": "Pifizer",
          //         "dose": "1",
          //         "date_of_dose": "2021-03-06",
          //         "data_source": "system",
          //         "created_at": "2020-09-02T21:31:58Z",
          //       }
          //     ],
          //     "certificates": [ // only if event name is user uploaded certificate
          //       {
          //         "name": "Pifizer",
          //         "dose": "1",
          //         "date_of_dose": "2021-03-06",
          //         "data_source": "system",
          //         "created_at": "2020-09-02T21:31:58Z",

          //       },
          //       {
          //         "name": "Covaxine",
          //         "dose": "2",
          //         "date_of_dose": "2021-04-06",
          //         "data_source": "system",
          //         "created_at": "2020-09-02T21:31:58Z",
          //       }
          //     ]
          //   },
          //   "vaccinated": true,
          //   "status": "success",
          //   "vaccination_sc_validity": 7,
          //   "dose_2_reminder_days": 30
          // }
          if (lodash.get(response, "statusCode", '') === 401) {
            dispatch({ type: 'UPDATE_MENU_STATUS', menuStatus: false })
          }
          if (lodash.get(response, "status", '') !== "success") {
            setPageLoadError(lodash.get(response, "response.data.message", t("RETRY_TEXT")))
          } else {
            return response;
          }
        }
        break;
      }
      case "JioHealthHub": {
        auth_token = lodash.get(params, "auth_token", '');
        source_user_id = lodash.get(params, "source_user_id", '');
        if (!auth_token || !source_user_id) {
          history.push('/');
        }
        else {
          user_details.current = {
            auth_token,
            source_id: source_id.toLowerCase(),
            jhh_id: source_user_id,
          };
          //const dataObj = vaccinationApiRequestBody({ jhh_id: source_user_id }, user_details.current);
          const response = await srGetUserVaccinationStatus(source_id);
          if (lodash.get(response, "status", '') !== "success") {
            setPageLoadError(lodash.get(response, "response.data.message", t("RETRY_TEXT")))
          } else {
            return response;
          }
        }
        break;
      }
      default: {
        setPageLoadError(t("RETRY_TEXT"))
        return;
      }
    }
  }

  const getUserInfoFromParams = (params = {}) => {
    if (ess().isFromEss) {
      return {
        relation: ess().eventData.source_relation,
        gender: ess().eventData.source_gender,
        age: parseInt(ess().eventData.source_age_years, 10)
      };
    }
    else if (params.source_id === "JioHealthHub") {
      return {
        relation: params.relation,
        gender: params.gender,
        age: parseInt(params.age, 10),
      };
    }

    else if (params.source_id === "MyJio") {
      return {
        relation: params.source_relation,
        gender: params.source_gender,
        age: parseInt(params.source_age_years, 10),
      };
    }
    return {};
  };

  const _getVaccineOptions = async () => {
    const response = await srGetVaccineOptions();
    if (lodash.get(response, "status", '') !== "success") {
      return;
    }
    let newVaccineOptions = lodash.get(response, "data", []);
    _setVaccineOptions(newVaccineOptions);
  }

  const _getJhhIdInfo = async () => {
    const auth_token = lodash.get(params, "auth_token", '');
    const source_id = lodash.get(params, "source_id", '').toLowerCase();
    const source_user_id = lodash.get(params, "source_user_id", '');
    const source_relation = lodash.get(params, "source_relation", '');
    const source_user_relation_id = lodash.get(params, "source_user_relation_id", '');
    if (!auth_token || !source_id || !source_user_id || !source_relation || !source_user_relation_id) {
      history.push('/');
    }
    const userDetailsObj = {
      auth_token,
      source_id,
      source_user_id,
      source_relation,
      source_user_relation_id
    };
    showLoading();
    let response;
    try {
      response = await isJhhIdVerified(userDetailsObj);
      const isSelf = source_relation.toLowerCase().includes("self");
      const bookingHealthId = response.jhh_id;
      if (isSelf) {
        dispatch({ type: 'UPDATE_USER', userData: { primaryHealthId: bookingHealthId, bookingHealthId: bookingHealthId } })
      } else {
        const userDetailsObj = {
          auth_token,
          source_id,
          source_user_id,
          source_relation: "Self",
          source_user_relation_id
        };
        const responseSelf = await isJhhIdVerified(userDetailsObj);
        dispatch({ type: 'UPDATE_USER', userData: { primaryHealthId: responseSelf.jhh_id || null, bookingHealthId: bookingHealthId } })
      }
      hideLoading();
    } catch (error) {
      setPageLoadError(lodash.get(error, "message", t("RETRY_TEXT"), ''));
      hideLoading();
      return false
    }
    if (lodash.get(response, "status", '') !== "success") {
      setPageLoadError(lodash.get(response, "response.data.message", t("RETRY_TEXT")));
      return false;
    }
    if (lodash.get(response, "validated") == "no") {
      history.push(`/vaccinations-v2/verifyjhhid?${urlParams.toString()}`)
      return false;
    }
    return true;
  }

  const _getEoiSscParams = async () => {
    if (eoiSscParams.current !== undefined) {
      return eoiSscParams.current;
    }
    const response = await srGetEoiSscParams();

    if (lodash.get(response, "status", '') !== "success") {
      setPageLoadError(lodash.get(response, "response.data.message", t("RETRY_TEXT")));
      return;
    }
    eoiSscParams.current = response;
    return response;
  }


  const _flowEngine = async () => {
    source_id = lodash.get(params, "source_id", '').toLowerCase();
    showLoading()
    getUserVaccinationStatus(params).then(async (response) => {
      hideLoading();
      if (response) {
        let vaccinated = lodash.get(response, "vaccinated", false);
        const { vaccine = {} } = response
        const { vaccines = [] } = vaccine || {}
        const getRequiredVaccineDetails = vaccines.filter(item => item.dose === getDoseLabels[dose])
        if (getRequiredVaccineDetails.length < 1) {
          vaccinated = false
        }
        _setVaccineDetails(getRequiredVaccineDetails)
        await _getVaccineOptions()
        if (vaccinated) {
          _setVaccinated(true);
          _checkAge(vaccinated);
        } else {
          _setVaccinated(false);
          _checkAge();
        }
      }
    })
  }

  const _checkAge = async (vaccinatedArg) => {
    const getJhhidInfo = lodash.get(params, "get_jhhid_info", "").toLowerCase() === "false" ? false : true;
    source_id = lodash.get(params, "source_id", '').toLowerCase();
    if (source_id === "emp_xp" && getJhhidInfo) {
      const proceedForward = await _getJhhIdInfo();
      if (!proceedForward) {
        return;
      }
    }
    userInfoFromParams.current = getUserInfoFromParams(params);

    const { age, gender, relation } = userInfoFromParams.current;
    dispatch({ type: 'UPDATE_USER', userData: { name, age, gender, relation } })
    if (userInfoFromParams.current && userInfoFromParams.current.relation) {
      let ageBelowLimit = false;
      showLoading();
      const response = await _getEoiSscParams();
      hideLoading();
      const sscAgeLimit = lodash.get(response, "data.ssc_min_age", '');
      if (sscAgeLimit != undefined && userInfoFromParams.current.age < sscAgeLimit) {
        ageBelowLimit = true;
      }
      if (ageBelowLimit && !vaccinatedArg) {
        _setShowVaccineDetails(false);
        setShowAgeWarning(true)
      }
      else {
        _setShowVaccineDetails(true);
        setShowAgeWarning(false)
      }
    }
  }

  const handleFileUploading = () => {
    setFileUploaded(true)
    _setShowVaccineDetails(false)
  }

  const updateVaccineInfo = async (vaccine_info) => {
    if (!user_details.current) return;
    source_id = lodash.get(params, "source_id", '');
    switch (source_id) {
      case "emp_xp": {
        const dataObj = { vaccine_info: vaccine_info }
        showLoading();
        const response = await srUpdateVaccineInfo(source_id, dataObj);
        hideLoading();
        if (lodash.get(response, "status") !== "success") {
          // setPageLoadError(lodash.get(response, "response.data.message", t("RETRY_TEXT")))
          return [false, lodash.get(response, "response.data.message", t("RETRY_TEXT"))];
        } else {
          return [true,""];
        }
      }
      case "JioHealthHub": {
        const dataObj = {
          jhh_id: source_user_id,
          vaccine_info
        }
        showLoading();
        const response = await srUpdateVaccineInfo(source_id, dataObj);
        hideLoading();
        if (lodash.get(response, "status", '') !== "success") {
          // setPageLoadError(lodash.get(response, "response.data.message", t("RETRY_TEXT")));
          return [false, lodash.get(response, "response.data.message", t("RETRY_TEXT"))];
        } else {
          return [true,""];
        }
      }
      default: {
        return false;
      }
    }
  }

  const loadData = () => {
    recordEssParams();
    _flowEngine();
  }

  useEffect(() => {
    loadData();
  }, [])

  if (pageLoadError) {
    return (<div className="vaccination-sc-page-load-error">{_getErrorMessage(pageLoadError)}</div>)
  }

  const renderDesktop = () => {
    return (
      <div className={`vaccination-sc-wrapper padding-top-very-small`}>
        {showVaccineDetails && !vaccinated &&
          <VaccinationDetailsContainer name={name} vaccinated={vaccinated} dose={dose} handleFileUploading={handleFileUploading} vaccineOptions={vaccineOptions} updateVaccineInfo={updateVaccineInfo} reloadData={loadData} />
        }
        {showVaccineDetails && vaccinated &&
          <VaccinationDetailsContainer name={name} vaccinated={vaccinated} dose={dose} vaccineDetails={vaccineDetails} vaccineOptions={vaccineOptions} updateVaccineInfo={updateVaccineInfo} reloadData={loadData} />
        }
        {showAgeWarning &&
          <ErrorComponent
            image={ic_age_limit}
            subText={t("AGE_WARNING_TXT")}
            showButton={false}
            textCss="no-appointments-text"
            subTextCss="no-appointments-sub-text"
          />
        }
        {
          fileUploaded &&
          <ErrorComponent
            image={ic_file_upload_success}
            text={t("FILE_UPLOAD_SUCCESS_LBL")}
            subText={t("FILE_UPLOAD_SUCCESS_TXT")}
            showButton={false}
            textCss="no-appointments-text"
            subTextCss="no-appointments-sub-text"
          />
        }
      </div>
    )
  }

  const renderMobile = () => {
    return (
      <div>
        <div style={styles.headerText}>
          {t("DOSE_LBL")}{getDoseLabels[dose]}
        </div>
        <hr />
        {showVaccineDetails && !vaccinated &&
          <VaccinationDetailsContainer name={name} vaccinated={vaccinated} dose={dose} handleFileUploading={handleFileUploading} vaccineOptions={vaccineOptions} updateVaccineInfo={updateVaccineInfo} reloadData={loadData} />
        }
        {showVaccineDetails && vaccinated &&
          <VaccinationDetailsContainer name={name} vaccinated={vaccinated} dose={dose} vaccineDetails={vaccineDetails} vaccineOptions={vaccineOptions} updateVaccineInfo={updateVaccineInfo} reloadData={loadData} />
        }
        {showAgeWarning &&
          <ErrorComponent
            image={ic_age_limit}
            subText={t("AGE_WARNING_TXT")}
            showButton={false}
            subTextCss="no-appointments-sub-text"
            imageHeight={240}
            imageWidth={240}
          />
        }
        {
          fileUploaded &&
          <ErrorComponent
            image={ic_file_upload_success}
            text={t("FILE_UPLOAD_SUCCESS_LBL")}
            subText={t("FILE_UPLOAD_SUCCESS_TXT")}
            showButton={false}
            textCss="no-appointments-text"
            subTextCss="no-appointments-sub-text"
            imageHeight={140}
            imageWidth={200}
          />
        }
      </div>
    )
  }

  return (
    <>{(isDesktop || isTablet) ? renderDesktop() : renderMobile()}</>
  )
}

export default VaccinationInfo;